export const getUmrahPrepaymentPrice = (tourPrice: number): number => {
  return Math.ceil(tourPrice * 0.1)
}
